'use client';

import { cssVariablesObjectToString } from './css-variables-object-to-string.mjs';
import { wrapWithSelector } from './wrap-with-selector.mjs';
function convertCssVariables(input, selector) {
  var sharedVariables = cssVariablesObjectToString(input.variables);
  var shared = sharedVariables ? wrapWithSelector(selector, sharedVariables) : "";
  var dark = cssVariablesObjectToString(input.dark);
  var light = cssVariablesObjectToString(input.light);
  var darkForced = dark ? selector === ":host" ? wrapWithSelector("".concat(selector, "([data-mantine-color-scheme=\"dark\"])"), dark) : wrapWithSelector("".concat(selector, "[data-mantine-color-scheme=\"dark\"]"), dark) : "";
  var lightForced = light ? selector === ":host" ? wrapWithSelector("".concat(selector, "([data-mantine-color-scheme=\"light\"])"), light) : wrapWithSelector("".concat(selector, "[data-mantine-color-scheme=\"light\"]"), light) : "";
  return "".concat(shared).concat(darkForced).concat(lightForced);
}
export { convertCssVariables };